import hotjar from '@hotjar/browser'

import { IS_PROD, IS_STAGING } from '~config'

const PROD_HOTJAR_SITE_ID = 6467873
const STAGING_HOTJAR_SITE_ID = 6467879
const HOTJAR_VERSION = 6

/**
 * Initialize Hotjar for tracking user behavior
 * Uses different tracking IDs for production and staging environments
 */
export const initHotjar = (): void => {
  if (!IS_PROD && !IS_STAGING) {
    return
  }

  const siteId = IS_PROD ? PROD_HOTJAR_SITE_ID : STAGING_HOTJAR_SITE_ID

  try {
    hotjar.init(siteId, HOTJAR_VERSION, {
      debug: false,
    })
  } catch (error) {
    console.error('Error initializing Hotjar:', error)
  }
}

export const identifyUser = (
  userId: string,
  userProperties?: Record<string, string | number | boolean | Date>,
): void => {
  if (hotjar.isReady()) {
    hotjar.identify(userId, userProperties || {})
  }
}

export { hotjar }
